import { getTopAdOffset } from './topAd.js';

const config = {
  restoreDistance: 96, // 通常のヘッダー表示へ戻すスクロール距離（px）。上部広告があるときはヘッダーが画面上部に届いてからの距離。
  resetBuffer: 2, // 境界付近で表示が往復しないようにする余裕（px）。
};

export const richHeroHeader = () => {
  const body = document.body;
  const hero = document.querySelector('.v4-rich-hero--fullscreen');
  if (!body.classList.contains('v4-rich-fullscreen-header') || !hero) return;

  const restoredClass = 'is-v4-rich-header-restored';
  let ticking = false;

  const updateHeader = () => {
    // ナビ開閉時の強制スクロールでは、保存しているヘッダー状態を変えない。
    if (!body.classList.contains('is-nav-active')) {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const restoreDistance = getTopAdOffset() + config.restoreDistance;

      if (scrollTop >= restoreDistance) {
        body.classList.add(restoredClass);
      } else if (scrollTop < restoreDistance - config.resetBuffer) {
        body.classList.remove(restoredClass);
      }
    }

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeader);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('pageshow', requestUpdate);
  requestUpdate();
};
